import React from 'react';
import Link from 'next/link';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';


export default function Footer() {
  return (
    <footer className="bg-card border-t border-border py-8 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        {/* Logo & Tagline */}
        <div className="flex items-center gap-2">
          <AppImage
            src="/assets/images/Black-and-Orange-Fitness-Club-Logo-Logo-02-16-2026_12_57_PM-removebg-preview-1771226976236.png"
            alt="VitalityStory Logo"
            width={150}
            height={40}
            className="h-8 w-auto mb-4"
          />
          <span className="text-lg font-serif font-light text-foreground">VitalityStory</span>
        </div>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
          <Link href="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </Link>
          <Link href="/terms" className="hover:text-foreground transition-colors">
            Terms
          </Link>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            <Icon name="CameraIcon" size={18} />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-xs text-muted-foreground">
          © 2026 VitalityStory. All rights reserved.
        </div>
      </div>
    </footer>
  );
}